import { createSlice } from "@reduxjs/toolkit";
import { fetchRevenueBreakdown } from "./thunk";
import { RevenueBreakdownResponse } from "./thunk";

interface RevenueBreakdownState {
  data: RevenueBreakdownResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: RevenueBreakdownState = {
  data: null,
  loading: false,
  error: null,
};

const revenueBreakdownSlice = createSlice({
  name: "revenueBreakdown",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRevenueBreakdown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRevenueBreakdown.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchRevenueBreakdown.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) ||
          action.error.message ||
          "Failed to fetch revenue breakdown data";
        // Set default values on error
        state.data = {
          data: [
            { name: "POS Generated", value: 0, color: "#65A19D" },
            { name: "Order Generated", value: 0, color: "#9B59B6" },
          ],
          date_from: null,
          date_to: null,
          warehouse_ids: null,
        };
      });
  },
});

export default revenueBreakdownSlice.reducer;

